import withRole from 'components/Security/withRole';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import { ROLE_SHOW_ORDER } from 'helpers/roles';

import List from './List';

const Baskets = () => {
  const ListSecured = withRole(ROLE_SHOW_ORDER, List);

  return (
    <DataGridStateContextProvider>
      <ListSecured />
    </DataGridStateContextProvider>
  );
};

export default Baskets;
